import { LinkSchema } from '@plangrid/scribble-client';

export const THUMBNAIL_SIZE_TYPE = {
  SMALL: 'small',
  MEDIUM: 'medium',
};

export const THUMBNAIL_PLACEHOLDER = '__THUMBNAIL_PLACEHOLDER__';

export type RelationshipType =
  | 'documentlineage'
  | 'sheetlineage'
  | 'rfi'
  | 'photo'
  | 'issue'
  | 'sheetversion'
  | 'documentversion'
  | 'form'
  | 'submittalitem'
  | 'asset';

export const RELATIONSHIP_TO_LINK_TYPE: Record<
  RelationshipType,
  LinkSchema['type']
> = {
  rfi: 'rfi',
  submittalitem: 'submittal',
  sheetlineage: 'acc_sheet_history',
  sheetversion: 'acc_sheet',
  documentlineage: 'acc_document',
  photo: 'photo',
  issue: 'issue',
  documentversion: 'document',
  form: 'form',
  asset: 'asset',
};

export const LINK_TO_RELATIONSHIP_TYPE: Record<
  LinkSchema['type'],
  RelationshipType
> = Object.entries(RELATIONSHIP_TO_LINK_TYPE).reduce(
  (acc, [relationshipType, linkType]) => {
    acc[linkType] = relationshipType as RelationshipType;
    return acc;
  },
  {} as Record<LinkSchema['type'], RelationshipType>,
);
